import React from 'react';
import styled from '@emotion/styled';
import { useI18n } from '~Hooks';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
  width: 100%;
  height: 100%;
  padding: 264px 120px 165px 120px;
  box-sizing: border-box;

  @media (orientation: landscape) {
    padding: 148px 67px 92px 67px;
    justify-content: center;
  }
`;

const Title = styled.h2`
  margin: 0 0 40px 0;
  color: rgb(19, 19, 22);
  font-family: Eina01-SemiBold;
  font-size: 80px;
  font-weight: 600;
  letter-spacing: 0px;
  line-height: 72px;
  text-align: center;

  @media (orientation: landscape) {
    font-size: 68px;
    line-height: 61px;
  }
`;

const Description = styled.p`
  margin: 0;
  color: rgb(19, 19, 22);
  font-family: Eina01-Regular;
  font-size: 48px;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 56px;
  text-align: center;

  @media (orientation: landscape) {
    font-size: 40px;
    line-height: 47px;
  }
`;

const Buttons = styled.div`
  display: flex;
  padding: 206px 0 0 0;

  @media (orientation: landscape) {
    padding: 115px 0 0 0;
  }
`;

const Button = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  border-radius: 80px;
  height: 224px;
  min-width: 300px;
  margin: 0 16px;
  padding: 0 30px;
  background: rgb(255, 255, 255);
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14),
    0px 1px 18px 0px rgba(0, 0, 0, 0.12);

  @media (orientation: landscape) {
    border-radius: 68px;
    height: 190px;
    min-width: 255px;
  }
`;

const ButtonLabel = styled.div<{ light?: boolean }>`
  color: rgb(19, 19, 22);
  font-family: Eina01-SemiBold;
  font-size: 48px;
  font-weight: 600;
  letter-spacing: 0px;
  line-height: 56px;
  text-align: center;
  padding: 8px 0 0 0;

  @media (orientation: landscape) {
    font-size: 40px;
    line-height: 47px;
  }
`;

type Props = {
  setLegalChoice: (choice: string) => void;
};

const LegalAge: React.FunctionComponent<Props> = ({ setLegalChoice }: Props) => {
  const { i18n } = useI18n();

  return (
    <Wrapper>
      <Title>{i18n('SSK.LegalAge.Title')}</Title>
      <Description>{i18n('SSK.LegalAge.SubTitle')}</Description>
      <Buttons>
        <Button
          onTouchStart={() => {
            setLegalChoice('no');
          }}>
          <ButtonLabel>{i18n('SSK.LegalAge.No')}</ButtonLabel>
        </Button>
        <Button
          onTouchStart={() => {
            setLegalChoice('yes');
          }}>
          <ButtonLabel>{i18n('SSK.LegalAge.Yes')}</ButtonLabel>
        </Button>
      </Buttons>
    </Wrapper>
  );
};

export default LegalAge;
